export default __webpack_public_path__ + "img/excel.0a9184e23786f41e180df16e3ed09dd3.png";